// The contact is newly created
export const TYPE_RECEIVED = 'received'

export const TYPE_SENT = 'sent'
